import ApiReceiver from '@/api/ApiReceiver';
import GetCommand from '@/api/GetCommand';
import RetryManager from '@/api/RetryManager';

class FormApiController {
  private readonly FORM_PATH;
  private retryManager: RetryManager = new RetryManager();
  private apiReceiver: ApiReceiver = new ApiReceiver();

  constructor(baseClientUrl: string | undefined) {
    this.FORM_PATH = `${baseClientUrl}/qti-player/api/qti-forms/`;
  }

  loadFormData<T = never>(formId: string): Promise<T | null> {
    return this.retryManager.runCommand(new GetCommand<T>(this.apiReceiver, this.FORM_PATH + formId));
  }
}

export default FormApiController;
